import React from 'react'
import axios from 'axios'
import {browserHistory} from 'react-router'
import {renderPopular, storage} from '../../utils'
import {Cells, Cell, CellBody, CellFooter, Grids, Grid, Dialog} from 'react-weui'

import IconHide from '../../images/liveroom/icon-data-hide.png'
import IconShow from '../../images/liveroom/icon-data-show.png'
import IconTips from '../../images/liveroom/icon-tips.png'

const STORATE_KEY = 'wk-liveroom-data'


class LiveroomRealData extends React.Component {
    constructor(props) {
        super(props)

        this.state = {
            showData: true,
            isLoading: true,
            isAlert: false,
            basicData: [
                {tips: '新增粉丝', num: 0},
                {tips: '访问人数', num: 0},
                {tips: '订单数', num: 0},
                {tips: '净收入(元)', num: 0, clsName: 'data-money'}
            ]
        }
        this.toggleDisplayData = this.toggleDisplayData.bind(this)
    }

    componentDidMount() {
        axios.get(`/api/datacenter/liveroom_data/${this.props.liveroomId}?data_type=basic`)
            .then(res => {
                if (res.data.code === 0) {
                    let basicData = res.data.data.basic_data
                    basicData = [{
                        num: renderPopular(basicData.new_fans),
                        tips: '新增粉丝'
                    }, {
                        num: renderPopular(basicData.uv),
                        tips: '访问人数'
                    }, {
                        num: renderPopular(basicData.order_count),
                        tips: '订单数'
                    }, {
                        num: renderPopular(basicData.earn),
                        tips: '净收入(元)',
                        clsName: 'data-money'
                    }]
                    this.setState({basicData, isLoading: false})
                }
            })
    }

    toggleDisplayData() {
        if (this.state.showData) {
            storage.setItem(STORATE_KEY, false)
            this.setState({showData: false})
        } else {
            storage.setItem(STORATE_KEY, true)
            this.setState({showData: true})
        }
    }

    render() {
        let {showData, isLoading, basicData} = this.state

        return (
            <div className="liveroom-real-data">
                <Dialog type="ios" title='提示' show={this.state.isAlert} buttons={[{
                    label: '确定',
                    onClick: () => this.setState({ isAlert: false }),
                }]}>
                    今日实时数据只有直播间所有者和管理员可见
                </Dialog>

                <div className="liveroom-page-titlebar weui-flex">
                    <span className="liveroom-page-titlebar-title weui-flex__item" onClick={() => this.setState({ isAlert: true })}>
                        <label className="liveroom-page-title-bar-text">今日实时数据</label>
                        <img className="liveroom-page-title-bar-tips" src={IconTips}/>
                    </span>
                    <span className="liveroom-page-titlebar-ft weui-flex__item" onClick={this.toggleDisplayData}>
                        <span className="liveroom-page-titlebar__tips hide">{showData ? '点击隐藏' : '点击显示'}</span>
                        <img className="liveroom-page-titlebar__img" src={showData ? IconShow : IconHide}/>
                    </span>
                </div>

                <div className="real-data-body" onClick={() => {location.assign(`/liveroom/${this.props.liveroomId}/datacenter`)}}>
                    <Grids>
                        {basicData.map((item, index) => (
                            <Grid className={"real-data__item " + (item.clsName || "")} key={index}>
                                <span className="real-data__block real-data__num">{showData ? (isLoading ? '-' : item.num) : "***"}</span>
                                <span className="real-data__block real-data__text">{item.tips}</span>
                            </Grid>
                        ))}
                    </Grids>
                </div>

                <Cells className="real-data-foot">
                    <Cell access onClick={() => {location.assign(`/liveroom/${this.props.liveroomId}/datacenter`)}}>
                        <CellBody/>
                        <CellFooter>查看更多</CellFooter>
                    </Cell>
                </Cells>
            </div>
        )
    }
}


export default LiveroomRealData


// WEBPACK FOOTER //
// ./src/components/liveroom/LiveroomRealData.js